const Flickity = require('flickity');

export default () => {

    const banners = document.querySelectorAll('[data-banner-slider]');
    if (banners.length) {
        window.addEventListener('load', () => {

            for (const banner of banners) {
                const ficlkity = new Flickity(banner, {
                    cellAlign: 'left',
                    contain: true,
                    prevNextButtons: false
                });
            }

        });
    }

}
